<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-kpi-rules" :class="{'full-size': showDateRange}">
    <div class="wy-rule-operator" :class="{'error-red': rule.operator==''||ruleDuplicate}">
      <el-select v-model="rule.operator" popper-class="kpi-rule-dropdown" placeholder="Select" @change="handleChange">
        <el-option
          v-for="item in operatorOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled">
        </el-option>
      </el-select>
    </div>
    <div ref="ruleValue" class="wy-rule-value" :class="{'error-red': isEmpty}">
      <div v-if="rule.operator==''||rule.operator=='>='||rule.operator=='<='">
        <vue-numeric v-bind:minus="false" v-bind:min="0" v-bind:precision="1" separator="," v-model="rule.value" placeholder="Enter value" @change="handleValueChange"></vue-numeric>
      </div>
      <div v-else-if="rule.operator=='+'||rule.operator=='-'">
        <vue-numeric v-bind:minus="false" separator="," v-bind:precision="1"  v-bind:min="0" v-model="rule.value" placeholder="Enter value"></vue-numeric> 
        <span class="rule-value-suffix">%</span>
      </div>
      <div v-else>
        <vue-numeric v-bind:minus="false" separator="," v-bind:precision="1" v-bind:min="0" v-model="rule.value" placeholder="Enter value"></vue-numeric> 
      </div>
    </div>
    <div v-if="showDateRange" ref="dateRangeDropDown" class="wy-kpi-date-range">
      <span class="date-range-label">compared to avg of</span>
      <el-menu ref="elMenu" :default-active="rule.lastDateNumber.toString()"  :hide-timeout="0" menu-trigger="hover" class="el-menu-demo" :class="{'error-red': rule.lastDateNumber==0}" mode="horizontal" @select="handleSelect">
        <el-submenu index="1" popper-class="popper-kpi-config-date-dropdown">
          <template v-if="rule.lastDateNumber==0" slot="title">Select comparison period</template>
          <template v-else slot="title">Last {{rule.lastDateNumber}} days</template>
          <el-menu-item index="0" disabled>Select comparison period </el-menu-item>
          <el-menu-item index="7">Last 7 days</el-menu-item>
          <el-menu-item index="30">Last 30 days</el-menu-item>
          <el-submenu index="2-4" popper-class='second-level-submenu'>
            <template slot="title">Custom</template>
              <el-menu-item index="0" disabled>Days</el-menu-item>
              <el-menu-item :index="dayNum.toString()" v-for="(dayNum, index) in numDays" :key="index">{{dayNum}}</el-menu-item>
          </el-submenu>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import VueNumeric from 'vue-numeric'

  export default {
    name: 'wy-kpi-date-range',
    props: ['controller', 'topic', 'lastDateNumber', 'rule', 'ruleIndex'],
    components: {
      VueNumeric
    },
    data() {
      return {
        module: this,
        activeIndex: '0',
        price: '',
        numDays: [],

        operatorOptions: [
          {
            value: '',
            label: 'Select rule',
            disabled: true
          },
          {
            value: '>=',
            label: '≥ (greater than or equal to)'
          },
          {
            value: '<=',
            label: '≤ (less than or equal to)'
          },
          {
            value: '+',
            label: '+ (relative increase by %)'
          },
          {
            value: '-',
            label: '- (relative decrease by %)'
          },
          {
            value: '+#',
            label: '+ (absolute increase by #)'
          },
          {
            value: '-#',
            label: '- (absolute decrease by #)'
          },
        ],

        ruleDuplicate: false,
        preMsgObj: null,
        isEmpty: false
      };
    },

    computed: {
      isDuplicateRuleSet() {
        let duplicate = false;
        
        return duplicate;
      },

      showDateRange() {
        return this.rule.operator != '' && this.rule.operator != '>=' &&  this.rule.operator != '<=';
      },

      duplicateErrorMsg() {
        if(this.topic.type == 'overall') {
          return '<div class="div-title">Error: Duplicate Ruleset</div><div>You have already entered the same ruleset for the selected metric. Please ensure that each ruleset is unique and represents a distinct condition.</div>' 
        }
        else {
          return '<div class="div-title">Error: Duplicate Ruleset</div><div>You have already entered the same ruleset for the selected topic and metric. Please ensure that each ruleset is unique and represents a distinct condition.</div>'
        }
        
      }
    },

    methods: {
      handleSelect(val) {
        this.activeIndex = val.toString()
        this.rule.lastDateNumber = parseInt(val);
        this.checkDuplicate();
        this.controller.checkRuleDuplicate();
      },

      handleValueChange() {
        this.checkDuplicate();
        this.controller.errorValidation();
        this.controller.checkRuleDuplicate();
      },

      handleChange() {
        this.checkRuleType();
        this.checkDuplicate();
        this.controller.checkRuleDuplicate();
      },

      checkRuleType() {
        if(this.rule.operator != '' && this.rule.operator != '>=' &&  this.rule.operator != '<=') {
          this.activeIndex = '30';
          this.rule.lastDateNumber = 30;
        }
        else {
          this.activeIndex = '0';
          this.rule.lastDateNumber = 0;
        }
      },

      checkDuplicate() {
        this.ruleDuplicate = false;
        this.topic.rules.forEach((rule, ruleIndex) => {
          if(this.ruleIndex != ruleIndex) {
            if(this.rule.operator == rule.operator) {
              this.handleDuplicateMsg();
            }
          }
        });
        if(!this.ruleDuplicate && this.preMsgObj) {
          this.preMsgObj.close()
          this.preMsgObj = null;
        }
      },

      handleDuplicateMsg() {
        this.ruleDuplicate = true;
        if(!this.preMsgObj) {
          this.preMsgObj = this.$message({
            message: this.duplicateErrorMsg,
            dangerouslyUseHTMLString: true,
            showClose: true,
            type: 'warning',
            duration: 5000,
            customClass: "kpi-topic-duplicate-warning",
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    },

    created() {
      this.activeIndex = this.rule.lastDateNumber.toString();
      this.numDays = [];
      for(let i=0; i<30; i++) {
        this.numDays.push(i+1)
      }
    },

    mounted() {
      if(this.rule && (this.rule.value !== 0 && this.rule.value == '')) {
        this.isEmpty = true;
      }
      this.$refs.ruleValue.querySelector('input').addEventListener('keypress',(e)=>{
        var keyCode = e.keyCode || e.which;
        
        if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
          e.preventDefault();
          return false;
        }
        
      })

      this.$refs.ruleValue.querySelector('input').addEventListener('input',(e)=>{
        setTimeout(()=>{  
          if(e.target.value.trim() == '') {
            this.isEmpty = true;
          }
          else {
            this.isEmpty = false;
          }
        },100)
      })
    }
  };
</script>

<style lang="scss">
  .wy-kpi-rules {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    position: relative;
    top: 0px;
    width: 345px;
    margin-bottom: 5px;
    .wy-kpi-date-range {
      // display: inline-block;
      width: 290px;
      position: relative;
      float: right;
      .date-range-label {
        top: -8px;
        position: relative;
      }

      .el-menu-demo {
        border: 0px #CCC solid;
        display: inline-block;
        position: relative;
        top: 6px !important;
        margin-left: 12px;
      }
      .el-menu-demo.error-red>.el-submenu.is-active .el-submenu__title {
        border: 1px #EBAFBA solid;
        // background-color: #FFF;
        background-color: #FFF4F4;
      }
      .el-menu--horizontal.el-menu {
        top: 21px;
      }
      .el-menu--horizontal>.el-submenu .el-submenu__title {
        height: 40px;
        line-height: 39px;
        border: 1px #CCC solid;
        padding: 0 15px 0 10px;
        background-color: #FFF;
      }
      .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border: 1px #106FBC solid;
        width: 150px;
        border-radius: 4px;
        background-color: #E8F1FF;
      }
      .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
        margin-top: 10px;
        margin-right: -6px;
        float: right;
        color: #106FBC;
        font-weight: 600;
      }
      .el-menu-demo.error-red .el-submenu__icon-arrow {
        color: #C0C4CC !important;
      }
    }
    .wy-rule-operator {
      position: relative;
      top: 7px;
      display: inline-block;
      .el-select {
        height: 36px;
        line-height: 37px;
        span.el-input__suffix {
          right: 2px;
        }
        .el-input--suffix .el-input__inner {
          height: 33px;
          border: 0px;
          background-color: transparent;
          padding-left: 10px;
        }
        .el-input .el-select__caret.is-reverse {
          top: -3px;
          position: relative;
        }
        .el-select__caret {
          color: #106FBC;
        }
      }
      .el-select>.el-input {
        height: 36px;
        border: 1px #106FBC solid;
        line-height: unset;
        margin-left: 10px;
        width: 218px;
        border-radius: 4px;
        background-color: #E8F1FF;
      }
    }
    .wy-rule-operator.error-red {
      .el-select__caret {
        color: #C0C4CC;
      }
    }
    .wy-rule-operator.error-red .el-select > .el-input {
      border: 1px #EBAFBA solid;
      // background-color: #FFF;
      background-color: #FFF4F4;
    }
    .wy-rule-operator.error-red .el-select > .el-input.is-focus {
      border: 1px #106FBC solid;
      background-color: #FFF;
      // background-color: #FFF4F4;
    }
    .wy-rule-value {
      display: inline-block;
      position: relative;
      top: 6px;
      left: 10px;
      input {
        height: 34px;
        border: 1px #106FBC solid;
        width: 86px;
        padding-left: 10px;
        border-radius: 4px;
        background-color: #E8F1FF;
        outline: none;
      }
      .rule-value-suffix {
        margin-left: 3px;
      }
    }
    .wy-rule-value {
      input:focus {
        background-color: #FFF !important;
        border: 1px #106FBC solid !important;
      }
    }
    .wy-rule-value.error-red input {
      border: 1px #EBAFBA solid !important;
      // background-color: #FFF;
      background-color: #FFF4F4;
    }
  }

  .wy-kpi-rules.full-size {
    width: 697px;
  }

  .el-menu--horizontal.popper-kpi-config-date-dropdown {
    .el-menu-item:not(.is-disabled):hover {
      background-color: #F4F6F8;
    }
    .el-menu .el-menu-item.is-active {
      background-color: #E8F1FF;
      color: #1A55AD;
      font-weight: 500;
    }
    .el-menu .el-submenu:not(.is-disabled):hover {
      background-color: #F4F6F8;
    }
    .el-menu .el-submenu.is-active {
      background-color: #E8F1FF;
      color: #1A55AD;
      .el-submenu__title:hover {
        // background-color: #E8F1FF !important;
        background-color: #E8F1FF !important;
      }
    }
    .el-menu .el-submenu.is-active:hover {
      // background-color: #E8F1FF !important;
    }
    .el-menu .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
      transform: unset !important;
    }
    .el-submenu__title i {
      color: #1A55AD;
      font-weight: 800;
    }
    // span.go-to-right {
    //   position: relative;
    //   left: 105px;
    //   color: #1A55AD;
    // }
    .second-level-submenu {
      .el-menu--popup-right-start {
        height: 200px;
        overflow-y: auto;
        overflow-x: hidden;  
        width: 72px;
        padding: 0 0px 0 0px;
        min-width: unset !important;

        &::-webkit-scrollbar {
          background-color: white !important;
          width: 6px !important;
        }
        &::-webkit-scrollbar-thumb{
          background: #CAD2DA !important;
          border-radius: 50px !important; 
        } 
      }
      .el-submenu .el-menu-item {
        min-width: unset !important;
      }
      li.el-menu-item.is-disabled {
        background-color: #E8F1FF !important;
        color: #1A55AD !important;
        opacity: 1 !important;
        padding: 0 0px 0 10px;
      }
      .el-menu .el-menu-item {
        padding: 0 10px 0 20px;
      }
    }
  }

  .kpi-topic-duplicate-warning {
    background-color: #FFF4F4;
    border-color: #DF96A3;
    padding: 15px 15px 15px 15px;
    width: 623px;
    height: 160px;

    .el-message__icon.el-icon-warning {
      background-image: url("../../assets/icons/icon_error_square.svg");
      height: 20px;
      width: 20px;
      background-repeat: no-repeat;
      background-size: 18px;
      top: -47px;
      position: relative;
    }
    .el-message__content {
      color: var(--site-font-secondary-color);
      font-size: 16px;
      font-weight: 500;
      width: calc(100% - 67px);
      line-height: 1.5;
      padding-left: 5px;
      padding-right: 0px;
      .div-title {
        padding-bottom: 25px;
      }
    }
    .el-icon-warning:before {
      content: unset;
    }
    .el-message__closeBtn {
      color: #5C5F62 !important;
      top: 28px;
    }
  }

  .kpi-rule-dropdown {
    li.el-select-dropdown__item.selected.is-disabled {
      // color: #C0C4CC !important;
    }
    .el-select-dropdown__item.selected {
      background-color: #E8F1FF;
      color: #1A55AD;
      font-weight: 500;
    }
  }
  
</style>